export enum HTTP_METHODS {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export enum JOB_TABS {
  OVERVIEW = 'Job Overview',
  INTERVIEW_STRUCTURE = 'Interview Structure',
}

export enum QUESTION_TYPES {
  CODING_QUESTION = 'codingquestion',
  DSA_QUESTION = 'dsaquestion',
  CULTURAL_QUESTION = 'culturalquestion',
  SOFT_SKILL_QUESTION = 'softskillquestion',
  SYSTEM_DESIGN_QUESTION = 'systemdesignquestion',
}

export enum CandidateStatus {
  CANDIDATE_IMPORTED = 'Import',
  RESUME_AI_SCREEN_PENDING = 'Resume Screen Pending',
  RESUME_AI_SHORTLISTED = 'Resume Shortlisted',
  RESUME_AI_REJECTED = 'Resume Rejected',
  INTERVIEW_SCHEDULE_PENDING = 'Schedule Pending',
  INTERVIEW_SCHEDULED = 'Interview Scheduled',
  INTERVIEW_RESCHEDULED = 'Interview Rescheduled',
  INTERVIEW_SHORTLISTED = 'Interview ShortListed',
  INTERVIEW_REJECTED = 'Interview Rejected',
  INTERVIEW_NO_SHOW = 'Interview No Show',
  INTERVIEW_PANEL_NO_SHOW = 'Interview Panel No Show',
  INTERVIEW_RESULT_PENDING = 'Interview Result Pending',
}

export enum DateRangeFilterEnum {
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  YESTERDAY = 'yesterday',
  NEXT_2_DAY = 'next_2_days',
  NEXT_1_WEEK = 'next_1_week',
  PAST_WEEK = 'past_week',
  PAST_2_WEEKS = 'past_2_weeks',
  LAST_30_DAYS = 'last_30_days',
}

export enum InterviewStatus {
  SCHEDULED = 'scheduled',
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  PENDING = 'pending',
  READY = 'ready',
  PAUSED = 'paused',
  DISCONNECTED = 'disconnected',
  EXPIRED = 'expired',
  ABANDONED = 'abandoned',
}